<script lang="ts">
  import HtmlParser from './HtmlParser.svelte';
  import CTooltip from '$shared/atoms/CTooltip/CTooltip.svelte';

  interface Props {
    value?: string;
    anchorTooltipLabel?: string;
    onclick?: (e: MouseEvent) => void;
  }

  let { value = '', anchorTooltipLabel = '', onclick }: Props = $props();
</script>

{#if value.includes('<a>')}
  {#each value.split('</a>').filter(Boolean) as val}
    {#each val.split('<a>') as item, i}
      {#if i === 0}
        <HtmlParser value={item} />
      {:else if anchorTooltipLabel}
        <CTooltip label={anchorTooltipLabel} width="auto">
          <a class="anchor" onclick={(e) => { e.stopPropagation(); onclick?.(e); }}> <HtmlParser value={item} /></a>
        </CTooltip>
      {:else}
        <a class="anchor" onclick={(e) => { e.stopPropagation(); onclick?.(e); }}> <HtmlParser value={item} /></a>
      {/if}
    {/each}
  {/each}
{:else if value.includes('<b>')}
  {#each value.split('</b>').filter(Boolean) as val}
    {#each val.split('<b>') as item, i}
      {#if i === 0}
        <HtmlParser value={item} />
      {:else}
        <span class="bold">{item}</span>
      {/if}
    {/each}
  {/each}
{:else if value.includes('<br/>')}
  {#each value.split('<br/>').filter(Boolean) as val, i}
    {#if i === 0}
      <HtmlParser value={val} />
    {:else}
      <div class="value">{val}</div>
    {/if}
  {/each}
{:else}
  {value}
{/if}

<style>
  .anchor {
    border-bottom: 2px solid rgba(0, 0, 0, 0.67);
  }
  .bold {
    font-weight: bold;
  }
</style>
